import { css } from '@emotion/css';
import { useState } from 'react';
import accountStyles from './account-option.style';
import userApi from 'apis/userApi';
import toast from 'react-hot-toast';
import LoadingIcon from 'components/loading/LoadingIcon';
import { AgencyRefundItem } from 'models/agentModel';
import Modal from 'components/modal/Modal';
import AgencyRefundDetail from './AgencyRefundDetail';

const listStatus = [
    {
        value: '0',
        label: 'Chưa nhận',
    },
    {
        value: '1',
        label: 'Đã nhận',
    },
];
function AgencyRefund() {
    const [orderData, setOrderData] = useState('0');
    const [recordList, setRecordList] = useState<AgencyRefundItem[]>([]);
    const [loading, setLoading] = useState(false);
    const [showFund, setShowFund] = useState(false);
    const [data, setData] = useState({} as AgencyRefundItem);

    const searchFund = async () => {
        setLoading(true);
        try {
            const { data } = await userApi.reportRefundSearch({ depositStatus: orderData });
            if (!data.msg) {
                setRecordList(data.htckInfoFEs);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const goDetail = (item: AgencyRefundItem) => {
        setShowFund(true);
        setData(item);
    };

    return (
        <>
            <div className={`${accountStyles.wrap}`}>
                <h6 className={accountStyles.title}>Hoàn Trả</h6>
                <div className={`${styles.elmSubmit}`}>
                    <p>Chọn hoàn trả</p>
                    <div className={accountStyles.wrapInput}>
                        <select className="input-common" value={orderData} onChange={(e) => setOrderData(e.target.value)}>
                            {listStatus.map((item) => (
                                <option value={item.value} key={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={`${styles.elmSubmit}`}>
                    <button  onClick={searchFund} className={`btn-primary ${accountStyles.btnSubmit}`}>
                        Tìm Kiếm
                    </button>
                </div>

                <div className="table-common">
                    {recordList ? (
                        <>
                            {recordList.length > 0 ? (
                                recordList.map((item, idx) => (
                                    <div className="col-table">
                                        <div className="row" key={idx}>
                                            <div className="col">
                                                <p>Thể loại:</p>
                                                <strong>{item.gameName}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Tiền hoàn trả:</p>
                                                <strong>{new Intl.NumberFormat().format(item.promo || 0)}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Chi tiết:</p>
                                                {item.gameId && (
                                                    <span className="btn-detail" style={{ padding: '4px 0', width: '100%', display: 'block' }} onClick={() => goDetail(item)}>
                                                        Xem
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-data">
                                    <img src={require('assets/images/icons/no-data.png')} alt="" />
                                    <p>Không có dữ liệu</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="no-data">
                            <img src={require('assets/images/icons/no-data.png')} alt="" />
                            <p>Không có dữ liệu</p>
                        </div>
                    )}
                </div>
            </div>
            {loading && <LoadingIcon />}

            <Modal isShow={showFund} onClose={() => setShowFund(false)} backdropColor="rgba(255,255,255, 0.7)" width="950px">
                <AgencyRefundDetail onClose={() => setShowFund(false)} itemRecord={data} />
            </Modal>
        </>
    );
}

const styles = {
    flex40: css`
        flex: 0 0 calc(40% - 32px);
    `,
    elmSubmit: css`
        max-width: 40%;
        margin: 15px auto;
        p {
            color: #000;
            padding-bottom: 10px;
        }
    `,
};

export default AgencyRefund;
